export default Object.freeze({
  AG000132: 'AG000132',
});



// WEBPACK FOOTER //
// ./src/enums/modules/forceEanByAgentEnum.js